import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'
import {articleAll, articleCategory} from '@/api/server/article'

import Banner from '@/components/Banner'
import Contact from '@/components/Contact'

export default {
  name: 'ArticleIndexPage',
  mixins: [commonMixin],
  data () {
    return {
      pagesize: 10,
      page: 1,
      total: 0,
      typeList: [],
      selectType: 0, //选中类别
      list: [],
      id: 0,
      category: null
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    Banner,
    Contact
  },
  computed: {
  },
  methods: {
    onDetail (item) {
      this.$router.push({name: 'article-detail', query: {id: item.id}})
    },
    _getList () {
      let id = this.id
      if (!this.id) {
        id = ''
      }
      let query = {
        id: id
      }
      articleAll(query).then((res) => {
          if (res.code === 200 && res.data) {
            this.list = res.data
          }
        }
      )
    },
    _getCategory () {
      articleCategory({id: this.id}).then( (res) => {
        if (res.code === 200) {
          this.category = res.data
        }
      })
    },
    reset () {
      this._getCategory()
      this._getList(null)
    },
    handleRoute (route) {
      if (route.name === 'article-index') {
        this.id = this.$route.query.id
        console.log('id', this.id)
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
  
}
